import { create } from "zustand";
import { persist } from "zustand/middleware";

type AuthStore = {
  accessToken?: string;
  refreshToken?: string;
  setToken: (accessToken: string, refreshToken: string) => void;
  resetToken: () => void;
};
const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      setToken: (accessToken: string, refreshToken: string) =>
        set({ accessToken, refreshToken }),
      resetToken: () => {
        set({ accessToken: undefined, refreshToken: undefined });
      },
    }),
    {
      name: "token",
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
      }),
    }
  )
);

export default useAuthStore;
